module.exports = new __parcel__URL__("gallery_1.21f06dfa.jpg").toString();